import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Spinner, Button, Badge } from "react-bootstrap";
import { CSVLink } from "react-csv";
import Pagination from "../Pagination/Pagination";
import { GetDojoName, GetGradeName } from "../Utils";

export default function ListReserves(props) {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");
  const [isLoading, setLoading] = useState(false);
  const [sortedBy, setSortedBy] = useState("createdAt-desc");
  const [users, setUsers] = useState([]);
  const [dojos, setDojos] = useState([]);
  const [grades, setGrades] = useState([]);
  const token = JSON.parse(ls.get("jwt"));
  var moment = require("moment");

  const PAGE_SIZE = 50;
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [pageUsers, setPageUsers] = useState([]);

  useEffect(() => {
    users.length === 0 ? GetUsers() : FilterUsers(users, currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const FilterUsers = (users, page) => {
    setPageUsers(
      users.filter(
        (u, idx) => idx >= (page - 1) * PAGE_SIZE && idx < page * PAGE_SIZE
      )
    );
  };

  const GetUsers = () => {
    setLoading(true);

    let dojosList = dojos;
    if (dojosList.length === 0) {
      dojosList = JSON.parse(ls.get("dojos"));
      setDojos(dojosList);
    }
    let gradesList = grades;
    if (gradesList.length === 0) {
      gradesList = JSON.parse(ls.get("grades"));
      setGrades(gradesList);
    }

    axios
      .get(
        `${API_URL}/temp-exams?populate=*&filters[state][$eq]=DRAFT&sort[0]=createdAt%3Adesc&pagination[pageSize]=2000`,
        headerRequest
      )
      .then((res) => {
        let exams = [];
        for (let i = 0; i < res.data.data.length; i++) {
          const e = res.data.data[i].attributes;
          let x = {
            docNumber: e.tempUser.data.attributes.docNumber,
            fullname:
              e.tempUser.data.attributes.lastname +
              ", " +
              e.tempUser.data.attributes.name,
            date: e.examination.data.attributes.date,
            mode: e.examination.data.attributes.mode,
            rank: e.examination.data.attributes.rank,
            place: e.examination.data.attributes.place,
            gradeId: e.grade_id,
            grade: GetGradeName(gradesList, e.grade_id),
            dojoId: e.dojo_id,
            dojo: GetDojoName(dojosList, e.dojo_id),
            createdAtSort: e.createdAt,
            createdAt: e.createdAt.substring(0, 10),
          };
          exams.push(x);
        }
        setUsers(exams);
        setPagination({ total: exams.length });
        FilterUsers(exams, 1);
        setLoading(false);
      });
  };

  const sortResultBy = (sortCol) => {
    setLoading(true);
    if (sortCol == "date-asc") {
      users.sort(function (a, b) {
        return moment(b.date).toDate() - moment(a.date).toDate();
      });
    }
    if (sortCol == "date-desc") {
      users.sort(function (a, b) {
        return moment(a.date).toDate() - moment(b.date).toDate();
      });
    }
    if (sortCol == "createdAt-asc") {
      users.sort(function (a, b) {
        return (
          moment(b.createdAtSort).toDate() - moment(a.createdAtSort).toDate()
        );
      });
    }
    if (sortCol == "createdAt-desc") {
      users.sort(function (a, b) {
        return (
          moment(a.createdAtSort).toDate() - moment(b.createdAtSort).toDate()
        );
      });
    }
    //console.log({ users });
    setUsers(users);
    setSortedBy(sortCol);
    setCurrentPage(1);
    FilterUsers(users, currentPage);
    setLoading(false);
  };

  const renderData = (
    <>
      <Table striped hover size="sm" responsive="sm">
        <thead>
          <tr>
            <th>DNI</th>
            <th>Nombre</th>
            <th>
              <Button
                variant="light"
                style={{
                  minWidth: "100px",
                  padding: "0px",
                  fontWeight: "bold",
                }}
                onClick={(e) => {
                  sortResultBy(
                    !sortedBy.includes("date") ||
                      (sortedBy.includes("date") && sortedBy === "date-asc")
                      ? "date-desc"
                      : "date-asc"
                  );
                }}
              >
                Fecha{" "}
                <Badge bg={sortedBy.includes("date") ? "primary" : "secondary"}>
                  {sortedBy === "date-asc" ? "↑" : "↓"}
                </Badge>
              </Button>
            </th>
            <th>Modo</th>
            <th>Lugar</th>
            <th>Grade</th>
            <th>Dojo</th>
            <th>
              <Button
                variant="light"
                style={{
                  minWidth: "100px",
                  padding: "0px",
                  fontWeight: "bold",
                }}
                onClick={(e) => {
                  sortResultBy(
                    !sortedBy.includes("createdAt") ||
                      (sortedBy.includes("createdAt") &&
                        sortedBy === "createdAt-asc")
                      ? "createdAt-desc"
                      : "createdAt-asc"
                  );
                }}
              >
                Creado{" "}
                <Badge
                  bg={sortedBy.includes("createdAt") ? "primary" : "secondary"}
                >
                  {sortedBy === "createdAt-asc" ? "↑" : "↓"}
                </Badge>
              </Button>
            </th>
          </tr>
        </thead>
        <tbody>
          {!users || users.length < 1 ? (
            <tr>
              <td colSpan="7" align="center">
                No hay datos.
              </td>
            </tr>
          ) : (
            pageUsers.map((u, index) => (
              <tr key={index}>
                <td align="center">{u.docNumber}</td>
                <td align="left">{u.fullname}</td>
                <td align="center">{u.date}</td>
                <td align="center">{u.mode}</td>
                <td align="center">{u.place}</td>
                <td align="center">{u.grade}</td>
                <td align="center">{u.dojo}</td>
                <td align="center">{u.createdAt}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={pagination.total}
        pageSize={PAGE_SIZE}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>EXPORTAR RESERVAS</h4>
      {!isLoading && users && users.length > 1 ? (
        <CSVLink
          data={users}
          filename={"faa-reserves.csv"}
          className="btn btn-success btn-sm"
        >
          DESCARGAR
        </CSVLink>
      ) : null}
      {isLoading ? <Spinner animation="border" /> : renderData}
    </Container>
  );
}
